module.exports = __webpack_public_path__ + "ff8c5aad1ac845729b16e911030f2a73.woff2";